"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.backwardsCompatibleGetSummaryData = exports.backwardsCompatibleGetLogoConfigs = exports.backwardsCompatibleGetFacets = exports.backwardsCompatibleGetBadgeFields = void 0;
_Object$defineProperty(exports, "getSummaryDataV8", {
  enumerable: true,
  get: function () {
    return _providerComponents.getSummaryDataV8;
  }
});
var _providerComponents = require("@kyruus/provider-components");
// this is exported at the top-level of the package; all other utils are used only internally, at least for now

const backwardsCompatibleGetBadgeFields = config => {
  if (config.darkship_use_list_page_searchv9) {
    return (0, _providerComponents.getBadgeFields)(config);
  }
  return (0, _providerComponents.getBadgeFieldsV8)(config);
};
exports.backwardsCompatibleGetBadgeFields = backwardsCompatibleGetBadgeFields;
const backwardsCompatibleGetSummaryData = (config, applyV9SummaryData) => {
  if (config.darkship_use_list_page_searchv9 || applyV9SummaryData) {
    return (0, _providerComponents.getSummaryData)(config);
  }
  return (0, _providerComponents.getSummaryDataV8)(config);
};
exports.backwardsCompatibleGetSummaryData = backwardsCompatibleGetSummaryData;
const backwardsCompatibleGetFacets = config => {
  if (config.darkship_use_list_page_searchv9) {
    return config.facets_v9;
  }
  return config.facets;
};
exports.backwardsCompatibleGetFacets = backwardsCompatibleGetFacets;
const backwardsCompatibleGetLogoConfigs = config => {
  if (config.darkship_use_list_page_searchv9) {
    return config.logos_v9;
  }
  return config.logos;
};
exports.backwardsCompatibleGetLogoConfigs = backwardsCompatibleGetLogoConfigs;